import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'title',
      type: 'input',
      label: '标题',
      placeholder: '请输入标题',
      rules: { required: true, message: '标题是必传的', trigger: 'blur' }
    },
    {
      field: 'link',
      type: 'input',
      label: '链接',
      placeholder: '请输入链接',
      rules: {
        required: true,
        message: '链接是必传的',
        trigger: 'blur'
      }
    },
    {
      field: 'type',
      type: 'select',
      label: '类型',
      placeholder: '请选择类型',
      options: [
        { title: '网页', value: 0 },
        { title: '小程序', value: 1 }
      ],
      rules: { required: true, message: '类型是必传的', trigger: 'blur' }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
